// extracted by mini-css-extract-plugin
module.exports = {"Infografica":"Infografica_Infografica__2pRQj","clickableBox":"Infografica_clickableBox__1wZZW"};